import { groupBy, isEmpty, propOr } from './fp';

// This function is to delete children without parent.
// If there is no value that have data, then there is no list to display
// ("hasData" contentConstraints from structure request).

export const cleanDeadBranches = (flatlist, accessor = v => v?.hasData) => {
  const getHId = v => v?.hierarchicalId || v?.id;
  if (flatlist.find(v => accessor(v) === true)) {
    const grouped = groupBy(v => propOr('#ROOT', 'parentId', v), flatlist);

    const filterEnabled = list =>
      list.filter(v => {
        if (accessor(v)) {
          return true;
        }
        const id = getHId(v);
        const children = propOr([], id, grouped);
        const enabledChildren = filterEnabled(children);
        return !isEmpty(enabledChildren);
      });

    return filterEnabled(flatlist);
  }
  if (flatlist.find(v => accessor(v) === false)) return [];
  return flatlist;
};
